import { connect } from 'react-redux'
import {
  loginUser,
} from '../../../store/auth'
import {
  forgotPassword,
  initForgotPassword,
} from '../../../store/password'

import Login from '../components/Login'

const mapDispatchToProps = {
  loginUser,
  forgotPassword,
  initForgotPassword,
}

const mapStateToProps = (state) => {
  const {
    errorMessage,
    message,
    content,
    isAuthenticated,
    isAuthenticating,
    needChangePassword,
  } = state.auth
  const {
    isForgotPasswordLoading,
    isForgotPasswordSuccess,
    forgotPasswordErrorMessage,
  } = state.password
  return {
    errorMessage,
    message,
    content,
    isAuthenticated,
    isAuthenticating,
    needChangePassword,
    isForgotPasswordLoading,
    isForgotPasswordSuccess,
    forgotPasswordErrorMessage,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Login)



// WEBPACK FOOTER //
// ./src/routes/Login/containers/Login.js